import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        // 少康
        path: '/extension',
        name: 'extension',
        meta: {
            title: "请稍后..."
        },
        component: () =>
            import ("@/views/businessList/businessList.vue")
            // component:()=>import("@/views/extensionCard/extensionCard")
    },
    // 瑞昌
    {
        path: '/chanOffice',
        name: 'chanOffice',
        meta: {
            title: "请稍后..."
        },
        // component: () => import("@/views/businessList/businessLists.vue")
        component: () =>
            import ("@/views/extensionCard/extensionCards")
    },

    // 商品页面
    {
        path: "/shop",
        name: "shop",
        component: () =>
            import ("@/views/businessList/shop.vue")

    },

    // 分享注册页面
    {
        path: "/share",
        name: "share",
        meta: {
            title: "注册"
        },
        component: () =>
            import ("@/views/share.vue")
    },
    // 下载页面
    {
        path: "/download",
        name: "download",
        meta: {
            title: "下载"
        },
        component: () =>
            import ("@/views/download")
    },
    // 用户协议
    {
        path: "/serveAgreement",
        name: "serveAgreement",
        meta: {
            title: "用户协议"
        },
        component: () =>
            import ("@/views/agreement/serve")
    },
    // 隐私协议
    {
        path: "/privateAgreement",
        meta: {
            title: "隐私协议"
        },
        name: "privateAgreement",
        component: () =>
            import ("@/views/agreement/privte")
    },
    // 通过分享页面跳转过去的
    // 用户协议
    {
        path: "/serveAgreements",
        name: "serveAgreements",
        component: () =>
            import ("@/views/agreements/serve")
    },
    // 隐私协议
    {
        path: "/privateAgreements",
        name: "privateAgreements",
        component: () =>
            import ("@/views/agreements/privte")
    },
    // 申请验证页面  少康用
    {
        path: "/infoRetained",
        name: "infoRetained",
        component: () =>
            import ("@/views/extensionCard/extensionCard")
    },
    // 渠道  瑞昌用
    {
        path: "/infoRetaineds",
        name: "infoRetaineds",
        component: () =>
            import ("@/views/extensionCard/extensionCards")
    },
    // 授权
    {
        path: "/authorization",
        name: "authorization",
        component: () =>
            import ("@/views/authorization/authorization")
    },
    // app操作中转页面
    {
        path: "/",
        name: "appOperation",
        component: () =>
            import ("@/views/appOprete/index")
    },
    // doudou  钱包活动分享列表 网申办卡、信用贷款
    {
        path: "/business",
        name: "business",
        component: () =>
            import ("@/views/business/index"),
        meta: {
            title: '网申办卡',
        },
    },
    {
        path: "/business/businessDetail",
        name: "businessDetail",
        component: () =>
            import ("@/views/business/businessDetail"),
        meta: {
            title: '推广',
        },
    },
    {
        path: "/businessExternal",
        name: "businessExternal",
        component: () =>
            import ("@/views/businessExternal/index"),
        meta: {
            title: '网申办卡',
        },
    },
    // 认证说明信息页面
    {
        path: "/explainInfo",
        name: "explainInfo",
        component: () =>
            import ("@/views/explain/index"),
        meta: {
            title: "认证说明"
        }
    },
    {
        path: "/appSuccess",
        name: "appSuccess",
        component: () =>
            import ("@/views/appSuccess/index"),
        meta: {
            title: "成功"
        }
    },
    // 公众号专用APP下载页面
    {
        path: "/downloadforpublic",
        name: "downloadforpublic",
        meta: {
            title: "下载"
        },
        component: () =>
            import ("@/views/download/index")
    },

    // 佳付通公众号专用APP下载页面
    {
        path: "/downloadforjft",
        name: "downloadforjft",
        meta: {
            title: "下载"
        },
        component: () =>
            import ("@/views/download/jftDown")
    },
    // 佳付通 - 用户协议
    {
        path: "/jftAerveAgreement",
        name: "jftAerveAgreement",
        meta: {
            title: "佳付通用户协议"
        },
        component: () =>
            import ("@/views/jftAgreement/serve")
    },
    // 佳付通 - 隐私协议
    {
        path: "/jftPrivateAgreement",
        meta: {
            title: "佳付通隐私协议"
        },
        name: "jftPrivateAgreement",
        component: () =>
            import ("@/views/jftAgreement/privte")
    },
    // 佳付通 - 分享注册页面
    {
        path: "/jftShare",
        name: "jftShare",
        meta: {
            title: "注册"
        },
        component: () =>
            import ("@/views/jftShare/index.vue")
    },
    // 佳付通 - 授权
    {
        path: "/authorization2",
        name: "authorization2",
        component: () =>
            import ("@/views/authorization/authorization2.vue")
    },
    //跳转支付宝支付
    {
        path: "/zfbAddress",
        name: "zfbAddress",
        meta: {
            title: "支付宝支付"
        },
        component: () =>
            import ("@/views/zfbAddress/index.vue")
    },
    {
        path: "/zfbFail",
        name: "zfbFail",
        component: () =>
            import ("@/views/zfbAddress/zfbFail.vue"),
        meta: {
            title: "失败"
        }
    },
    //唤起支付宝支付
    {
        path: "/tuneUpAlipay",
        name: "tuneUpAlipay",
        meta: {
            title: "支付宝支付"
        },
        component: () =>
            import ("@/views/zfbAddress/tuneUpAlipay.vue")
    },
    //我是队长 公众号专用APP下载页面
    {
        path: "/downloadfordz",
        name: "downloadfordz",
        meta: {
            title: "下载"
        },
        component: () =>
            import ("@/views/download/dzDown.vue")
    },
    // 我是队长 - 用户协议
    {
        path: "/dzAerveAgreement",
        name: "dzAerveAgreement",
        meta: {
            title: "我是队长用户协议"
        },
        component: () =>
            import ("@/views/dzAgreement/serve")
    },
    // 我是队长 - 隐私协议
    {
        path: "/dzPrivateAgreement",
        meta: {
            title: "我是队长隐私协议"
        },
        name: "dzPrivateAgreement",
        component: () =>
            import ("@/views/dzAgreement/privte")
    },
    // 我是队长 - 采购协议
    {
        path: "/purchaseAgreement",
        name: "purchaseAgreement",
        component: () =>
            import ("@/views/dzAgreement/purchaseAgreement.vue")
    },
    // 我是队长 - 分享注册页面
    {
        path: "/dzShare",
        name: "dzShare",
        meta: {
            title: "注册"
        },
        component: () =>
            import ("@/views/dzShare/index.vue")
    },
    // 我是队长 - 授权
    {
        path: "/authorization3",
        name: "authorization3",
        component: () =>
            import ("@/views/authorization/authorization3.vue")
    },
    // 商户通 - 授权
    {
        path: "/authorization4",
        name: "authorization4",
        component: () =>
            import ("@/views/authorization/authorization4.vue")
    },
    //红包
    {
        path: "/redEnvelopes",
        name: "redEnvelopes",
        component: () =>
            import ("@/views/redEnvelopes/index.vue")
    },
    //金盒子- 红包
    {
        path: "/jhzRedEnvelopes",
        name: "jhzRedEnvelopes",
        component: () =>
            import ("@/views/redEnvelopes/jhz.vue")
    },
    //佳付通注册送红包
    {
        path: "/registForRedEnvelopes",
        name: "registForRedEnvelopes",
        component: () =>
            import ("@/views/registForRedEnvelopes/index.vue")
    },
    // 支持银行
    {
        path: "/recommendBankList",
        name: "recommendBankList",
        component: () =>
            import ("@/views/bankList/recommendBankList.vue")
    },

    //佳付通-改成佳佳乐隐私政策
    {
        path: "/jiajialePrivte",
        name: "jiajialePrivte",
        component: () =>
            import ("@/views/jftAgreement/jiajialePrivte.vue")
    },
    //佳付通-改成佳佳乐用户服务协议
    {
        path: "/jiajialeServe",
        name: "jiajialeServe",
        component: () =>
            import ("@/views/jftAgreement/jiajialeServe.vue")
    },
    // //收银台
    // {
    //     path: "/cashier",
    //     name: "cashier",
    //     component: () =>
    //         import ("@/views/cashier/index.vue")
    // },
    // //成功
    // {
    //     path: "/cashierSuccess",
    //     name: "cashierSuccess",
    //     component: () =>
    //         import ("@/views/cashier/success.vue")
    // },
    // //失败
    // {
    //     path: "/cashierFail",
    //     name: "cashierFail",
    //     component: () =>
    //         import ("@/views/cashier/fail.vue")
    // },
    //展示费率
    {
        path: "/showRate",
        name: "showRate",
        component: () =>
            import ("@/views/showRate/index.vue")
    },
    //商城活动
    {
        path: "/newActive",
        name: "newActive",
        component: () =>
            import ("@/views/newActive/index.vue")
    },
    //权益卡券
    {
        path: "/equityCard",
        name: "equityCard",
        component: () =>
            import ("@/views/equityCard/index.vue")
    },
    //码牌 规则说明
    {
        path: "/ruleDescription",
        name: "ruleDescription",
        component: () =>
            import ("@/views/ruleDescription/index.vue")
    },
    //码牌 规则说明2
    {
        path: "/newRuleDescription",
        name: "newRuleDescription",
        component: () =>
            import ("@/views/ruleDescription/index2.vue")
    },
    //海科下载页面
    {
        path: "/appDownload",
        name: "appDownload",
        component: () =>
            import ("@/views/appDownload/index.vue")
    },
    //海科微信二次认证新手引导
    {
        path: "/noviceGuidance",
        name: "noviceGuidance",
        component: () =>
            import ("@/views/noviceGuidance/index.vue")
    },
    // 梦想客 - 用户协议
    {
        path: "/mxkAerveAgreement",
        name: "mxkAerveAgreement",
        meta: {
            title: "梦想客用户协议"
        },
        component: () =>
            import ("@/views/mxkAgreement/serve")
    },
    // 梦想客 - 隐私协议
    {
        path: "/mxkPrivateAgreement",
        meta: {
            title: "梦想客隐私协议"
        },
        name: "mxkPrivateAgreement",
        component: () =>
            import ("@/views/mxkAgreement/privte")
    },
     // 梦想客 - 用户协议
     {
        path: "/mxkAerveAgreementB",
        name: "mxkAerveAgreementB",
        meta: {
            title: "梦想客用户协议"
        },
        component: () =>
            import ("@/views/mxkAgreement/serveB")
    },
    // 梦想客 - 隐私协议
    {
        path: "/mxkPrivateAgreementB",
        meta: {
            title: "梦想客隐私协议"
        },
        name: "mxkPrivateAgreementB",
        component: () =>
            import ("@/views/mxkAgreement/privteB")
    },
    // 梦想客 - 分享注册页面
    {
        path: "/mxkShare",
        name: "mxkShare",
        meta: {
            title: "注册"
        },
        component: () =>
            import ("@/views/mxkShare/index.vue")
    },
    // 梦想客 - 授权
    {
        path: "/mxkAuthorization",
        name: "mxkAuthorization",
        component: () =>
            import ("@/views/authorization/mxkAuthorization.vue")
    },
    // 梦想客 - 上线通知
    {
        path: "/goonline",
        name: "goonline",
        component: () =>
            import ("@/views/goonline/index.vue")
    },
    // 梦想客 - 上线通知2
    {
        path: "/goonline2",
        name: "goonline2",
        component: () =>
            import ("@/views/goonline/index2.vue")
    }, // 梦想客 - 上线通知2
    {
        path: "/goonline3",
        name: "goonline3",
        component: () =>
            import ("@/views/goonline/index3.vue")
    },
    //海科 消费券图片H5(带下载)
    {
        path:"/couponsDown",
        name:"couponsDown",
        component:()=>
            import("@/views/hkmcCoupons/couponsDown.vue")
    },

    //海科 消费券图片H5
    {
        path:"/coupons",
        name:"coupons",
        component:()=>
            import("@/views/hkmcCoupons/coupons.vue")
    },
    // 海科  补充资质拿现金红包活动-图片H5
    {
        path:"/qualificationCash",
        name:"qualificationCash",
        component:()=>
            import("@/views/activity/index.vue")
    },
    // 企业微信
    {
        path:"/open",
        name:"open",
        component:()=>
            import("@/views/open/index.vue")
    },
    // 企业微信
    {
        path:"/qiyeweixin",
        name:"qiyeweixin",
        component:()=>
            import("@/views/qiyeweixin/index.vue")
    }

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
